function CategoryItem() {
  return (
    <div className="categories-item sk" style={{ minWidth: "100px", height: "100%" }}>
      {" "}
    </div>
  )
}

export default CategoryItem
